import ErrorAlert from "@/utility/ErrorAlert";
import http from "@/axios/http-common";

// Base URL: /api/v1/kmkp/kepatuhan-identifikasi-pasien
const BASE = "/kmkp/kepatuhan-identifikasi-pasien";
const DASHBOARD = "/kmkp/kepatuhan-identifikasi-pasien-dashboard";

function handleError(err: any) {
  ErrorAlert.showErrorAlert(err);
  return Promise.reject(err);
}

// --- Session CRUD ---

async function getSessions(params?: any) {
  return await http.getDataParam(BASE, { params }).catch(handleError);
}

async function getSession(id: number) {
  return await http.getData(`${BASE}/${id}`).catch(handleError);
}

async function createSession(data: any) {
  return await http.postData(BASE, data).catch(handleError);
}

async function updateSession(id: number, data: any) {
  return await http.putData(`${BASE}/${id}`, data).catch(handleError);
}

async function deleteSession(id: number) {
  return await http.deleteData(`${BASE}/${id}`).catch(handleError);
}

// --- Nested: Observations (per-event) ---

async function addObservation(sessionId: number, data: any) {
  return await http.postData(`${BASE}/${sessionId}/observations`, data).catch(handleError);
}

async function updateObservation(sessionId: number, obsId: number, data: any) {
  return await http.putData(`${BASE}/${sessionId}/observations/${obsId}`, data).catch(handleError);
}

async function deleteObservation(sessionId: number, obsId: number) {
  return await http.deleteData(`${BASE}/${sessionId}/observations/${obsId}`).catch(handleError);
}

// --- Nested: RTL ---

async function addRtl(sessionId: number, data: any) {
  return await http.postData(`${BASE}/${sessionId}/rtls`, data).catch(handleError);
}

async function updateRtl(sessionId: number, rtlId: number, data: any) {
  return await http.putData(`${BASE}/${sessionId}/rtls/${rtlId}`, data).catch(handleError);
}

async function deleteRtl(sessionId: number, rtlId: number) {
  return await http.deleteData(`${BASE}/${sessionId}/rtls/${rtlId}`).catch(handleError);
}

// --- Nested: KTD Events ---

async function addKtdEvent(sessionId: number, data: any) {
  return await http.postData(`${BASE}/${sessionId}/ktd-events`, data).catch(handleError);
}

async function updateKtdEvent(sessionId: number, ktdId: number, data: any) {
  return await http.putData(`${BASE}/${sessionId}/ktd-events/${ktdId}`, data).catch(handleError);
}

async function deleteKtdEvent(sessionId: number, ktdId: number) {
  return await http.deleteData(`${BASE}/${sessionId}/ktd-events/${ktdId}`).catch(handleError);
}

// --- 3-Tier Signing ---

async function signPencatat(id: number, password: string) {
  return await http.putData(`${BASE}/${id}/sign-pencatat`, { password }).catch(handleError);
}

async function signVerifikator(id: number, password: string) {
  return await http.putData(`${BASE}/${id}/sign-verifikator`, { password }).catch(handleError);
}

async function signKepalaUnit(id: number, password: string) {
  return await http.putData(`${BASE}/${id}/sign-kepala-unit`, { password }).catch(handleError);
}

// --- Dashboard ---

async function getDashboard(params: any) {
  return await http.getDataParam(DASHBOARD, { params }).catch(handleError);
}

// --- PDF ---

function getPdfUrl(id: number): string {
  return `${http.apiUrl}${BASE}/${id}/pdf`;
}

export default {
  getSessions,
  getSession,
  createSession,
  updateSession,
  deleteSession,
  addObservation,
  updateObservation,
  deleteObservation,
  addRtl,
  updateRtl,
  deleteRtl,
  addKtdEvent,
  updateKtdEvent,
  deleteKtdEvent,
  signPencatat,
  signVerifikator,
  signKepalaUnit,
  getDashboard,
  getPdfUrl,
};
